var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "cargo-advance-search",
              staticStyle: {
                width: "100%",
                "margin-top": "5px",
                "min-width": "1280px"
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "middle", "label-width": "100px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: {
                              width: "230px",
                              "padding-left": "10px"
                            },
                            attrs: {
                              no: "1",
                              "select-type": _vm.selectTypeNames.TENANT,
                              cache: false,
                              filterable: "",
                              clearable: "",
                              "custom-label": function(item) {
                                return "[" + item.id + "]" + item.name
                              },
                              "callback-method-type": "obj",
                              "default-value": String(_vm.filter.tenant) || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.filter.tenant = p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CarrierShip"),
                            "label-width": "70px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: {
                              width: "230px",
                              "padding-left": "10px"
                            },
                            attrs: {
                              "tag-value": "code",
                              filterable: "",
                              clearable: "",
                              multiple: true,
                              "static-options": _vm.RECEIPT_CARRIERS
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.carriers = [].concat(p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Channel"),
                            "label-width": "70px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: {
                              width: "230px",
                              "padding-left": "10px"
                            },
                            attrs: {
                              "tag-value": "code",
                              filterable: "",
                              clearable: "",
                              "static-options": _vm.RECEIPT_CHANNELS
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.channel = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "padding-left": "10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "3", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.filter.pageNum = 1
                                  _vm.queryHandler()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Query")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "4", type: "primary" },
                              on: { click: _vm.addHandler }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "5", type: "primary" },
                              on: { click: _vm.editHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Edit")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "6", type: "danger" },
                              on: { click: _vm.deleteHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_OrderDelete")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "flex-grow": "1" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  no: "grid",
                  "config-module": "101425",
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.girdParams,
                  "grid-options": _vm.gridOptions
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.girdParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.girdParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-pagination" },
            [
              _c("cargo-pagination", {
                attrs: {
                  no: "pagination",
                  "config-module": "101425",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.queryHandler
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "settingDialog",
          attrs: {
            visible: _vm.settingDialog.visible,
            title: _vm.settingDialog.title,
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.settingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-width": "130px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: { label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          no: "7",
                          "select-type": _vm.selectTypeNames.TENANT,
                          disabled: _vm.settingDialog.isEdit,
                          cache: false,
                          filterable: "",
                          clearable: "",
                          "custom-label": function(item) {
                            return "[" + item.id + "]" + item.name
                          },
                          "callback-method-type": "obj",
                          "default-value":
                            String(_vm.settingDialog.form.tenant) || "",
                          "static-options": _vm.tenants
                        },
                        on: { parentCallBack: _vm.changeTenant }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CarrierShip"),
                        "label-width": "130px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          "tag-value": "code",
                          filterable: "",
                          clearable: "",
                          "default-value": _vm.settingDialog.form.carrier,
                          "static-options": _vm.RECEIPT_CARRIERS
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.settingDialog.form.carrier = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lable-blue",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Channel"),
                        "label-width": "130px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          "tag-value": "code",
                          filterable: "",
                          clearable: "",
                          "default-value": _vm.settingDialog.form.channel,
                          "static-options": _vm.RECEIPT_CHANNELS
                        },
                        on: { parentCallBack: _vm.changeChannel }
                      })
                    ],
                    1
                  ),
                  _vm.settingDialog.form.channel ===
                  _vm.RECEIPT_CHANNEL_EMAIL.code
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Title"),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      "tag-value": "code",
                                      filterable: "",
                                      clearable: "",
                                      placeholder: " ",
                                      "default-value":
                                        _vm.settingDialog.form.titleOperator,
                                      "static-options": _vm.RECEIPT_OPERATORS
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.settingDialog.form.titleOperator =
                                          p.value
                                      }
                                    }
                                  }),
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "200px",
                                      "margin-left": "10px"
                                    },
                                    attrs: { no: "title" },
                                    model: {
                                      value: _vm.settingDialog.form.title,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settingDialog.form,
                                          "title",
                                          $$v
                                        )
                                      },
                                      expression: "settingDialog.form.title"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.Content"),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      "tag-value": "code",
                                      filterable: "",
                                      clearable: "",
                                      placeholder: " ",
                                      "default-value":
                                        _vm.settingDialog.form.contentOperator,
                                      "static-options": _vm.RECEIPT_OPERATORS
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.settingDialog.form.contentOperator =
                                          p.value
                                      }
                                    }
                                  }),
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "200px",
                                      "margin-left": "10px"
                                    },
                                    attrs: { no: "content" },
                                    model: {
                                      value: _vm.settingDialog.form.content,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settingDialog.form,
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression: "settingDialog.form.content"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "13", type: "primary" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "14" },
                  on: {
                    click: function($event) {
                      _vm.settingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }